export default __webpack_public_path__ + "static/media/330_store04-jp-mobile.cda79543.png";